import React from "react";
import { LOGO } from "@/data/mock";
import { cn } from "@/lib/utils";

// The AuraMax mark: supplied logo asset (white A inside aura radiation).
export function Logo({ size = 36, className, glow = true }) {
  return (
    <span
      className={cn("relative inline-flex shrink-0 items-center justify-center", className)}
      style={{ width: size, height: size }}
    >
      {glow && (
        <span
          className="absolute inset-0 rounded-full aura-radial blur-md opacity-60"
          aria-hidden
        />
      )}
      <img
        src={LOGO}
        alt="AuraMax"
        className="relative z-10 h-full w-full object-contain rounded-[22%]"
        draggable={false}
      />
    </span>
  );
}

export function Wordmark({ className, showMark = true, size = 32 }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      {showMark && <Logo size={size} />}
      <span className="font-mark text-[1.15rem] font-extrabold tracking-tight text-white">
        AURAMAX
      </span>
    </div>
  );
}
